module.exports = __webpack_public_path__ + "img/camera.de72d5d7.svg";